import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Settings, User } from 'lucide-react';
import { ROUTES } from '@/constants';
import { Button } from '@/components/ui';
import { useAuth } from '@/context/AuthContext';
import { authService } from '@/services/auth.service';
import { toast } from 'sonner';

export function UserMenu() {
  const [open, setOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const { user, clearSession } = useAuth();
  const displayName = user?.name || user?.email || 'Usuário';

  useEffect(() => {
    const onClick = (event) => {
      if (!ref.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    setOpen(false);
    try {
      await authService.logout();
    } catch {
      // Session may already be invalid — still clear local state
    } finally {
      clearSession();
      toast.success('Sessão encerrada');
      navigate(ROUTES.LOGIN);
      setLoggingOut(false);
    }
  };

  return (
    <div className="relative" ref={ref}>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen((value) => !value)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <User size={16} aria-hidden />
        <span className="max-w-28 truncate">{displayName}</span>
      </Button>
      {open ? (
        <div
          role="menu"
          className="absolute right-0 z-20 mt-2 w-52 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--card)] p-1 shadow-[var(--shadow)]"
        >
          <button
            type="button"
            role="menuitem"
            className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm hover:bg-[var(--muted)]"
            onClick={() => {
              setOpen(false);
              navigate(ROUTES.SETTINGS);
            }}
          >
            <User size={16} aria-hidden />
            Meu perfil
          </button>
          <button
            type="button"
            role="menuitem"
            className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm hover:bg-[var(--muted)]"
            onClick={() => {
              setOpen(false);
              navigate(ROUTES.SETTINGS);
            }}
          >
            <Settings size={16} aria-hidden />
            Configurações
          </button>
          <button
            type="button"
            role="menuitem"
            className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-[var(--destructive)] hover:bg-[var(--muted)]"
            onClick={handleLogout}
            disabled={loggingOut}
          >
            <LogOut size={16} aria-hidden />
            Sair
          </button>
        </div>
      ) : null}
    </div>
  );
}
